export enum BalanceStatus {
  NoFunds = 'no_funds',
  NoInvestments = 'no_investments',
  Invested = 'invested',
}
